import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormField } from 'src/app/shared/interfaces/form-fields';

export interface Header {
  key: string;
  label: string;
  sortable?: boolean;
}

export interface ActionItem {
  label: string;
  action: (item: any) => void;
  styleClass?: string;
}

@Component({
  selector: 'app-generic-table',
  templateUrl: './generic-table.component.html',
  styleUrls: ['./generic-table.component.scss'],
})
export class GenericTableComponent implements OnChanges {
  @Input() headers: Header[] = [];
  @Input() data: any[] = [];
  @Input() pageNumber: number = 1;
  @Input() pageSize: number = 10;
  @Input() totalRecords: number = 0;
  @Input() totalPages: number | any = 0;
  @Input() actionMenu: ActionItem[] = [];
  @Input() filterActionMenuFn?: (actionMenu: ActionItem[], row: any) => ActionItem[];
  @Input() formGroup!: FormGroup;
  @Input() formFields: FormField[] = [];
  @Input() searchText: string = '';
  @Input() searchTextPlaceholder: string = 'Search';
  @Output() pageChange = new EventEmitter<number>();
  @Output() sortChange = new EventEmitter<any>();
  @Output() actionPerformed = new EventEmitter<{ item: any; action: (item: any) => void }>();
  @Output() filterTableEvent = new EventEmitter<any>();
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() pageSizeChange = new EventEmitter<number>();

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headers']) {
    }
    if (changes['data']) {
    }
  }

  sort(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.sortChange.emit({ column, direction: this.sortDirection });
  }

  getSortIcon(column: string): string {
    if (this.sortColumn !== column) return 'fa-sort';
    return this.sortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }

  onAction(item: any, action: (item: any) => void): void {
    this.actionPerformed.emit({ item, action });
  }

  onFilterTable(filters: any): void {
    this.filterTableEvent.emit(filters);
  }

  onSearchTextChange(searchText: string): void {
    this.searchTextChange.emit(searchText);
  }

  onPageSizeChange(newPageSize: number): void {
    this.pageSize = newPageSize;
    this.pageSizeChange.emit(newPageSize);
    this.pageChange.emit(1);
  }

  getStatusClass(status: string): string {
    let classes = '';
    switch (status) {
      case 'Active':
        classes = 'anq-status-success';
        break;
      case 'Deactivated':
      case 'In Active':
        classes = 'anq-status-danger';
        break;
      case 'Deleted':
        classes = 'anq-status-danger';
        break;
      default:
        classes = '';
    }
    return classes;
  }

  getFilteredActionMenu(row: any): ActionItem[] {
    if (this.filterActionMenuFn && Array.isArray(this.actionMenu)) {
      const filtered = this.filterActionMenuFn(this.actionMenu, row);
      return Array.isArray(filtered) ? filtered : [];
    }
    return Array.isArray(this.actionMenu) ? this.actionMenu : [];
  }

  hasAnyActions(): boolean {
    return Array.isArray(this.data) && this.data.some(item => this.getFilteredActionMenu(item).length > 0);
  }
}